module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-form-row validate-code"
  }, [_c('label', {
    staticClass: "s-form-label"
  }, [_vm._v("\n    请填写" + _vm._s(_vm.type == 'email' ? '邮箱验证码' : '手机校验码') + "：\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "s-form-info"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-code",
    attrs: {
      "placeholder": '请输入' + (_vm.type == 'email' ? '邮箱验证码' : '手机校验码')
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }, _vm.validateCode]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "s-button form-get-code",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取" + _vm._s(_vm.type == 'email' ? '邮箱验证码' : '手机校验码'))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTips),
      expression: "showTips"
    }],
    staticClass: "s-form-subtext"
  }, [_vm._v("\n      验证码已发出，请注意\n      "), (_vm.type == 'email') ? _c('span', [_vm._v("查收邮箱")]) : _c('span', [_vm._v("查收短信")]), _vm._v("\n      ，如果没有收到，你可以在"), _c('span', {
    staticClass: "orange"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("秒后要求系统重新发送\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-573213ac!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/send_code.vue
// module id = oBV8
// module chunks = 15